<template>
	<div class="plus_d " style="">
		<Tou></Tou>
		<el-breadcrumb class="w1500 pt-30" separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/plus_details' }">plus_detail</el-breadcrumb-item>
			<el-breadcrumb-item>collect_points</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="w1500 rel detail_nr br-10 mt-30 bj-0 pt-100 pb-45 mb-190" style="">
			<div class="tit-36  B-500 montserMedium collectformtitle" style="width:100%;text-align: center ;color:#333333;">Collect your GoodWe PLUS+ points!</div>
			<div class="tit-18 pt-10 collectformtitle2"style="width:100%;text-align: center;color:#a3a5a4">Select model type and enter SN of your inverter and batteries. Double points </div>
			<div class="tit-18  collectformtitle3" style="width:100%;text-align: center;color:#a3a5a4">for Energy Storage Combo(Battery + Inverter)!</div>
			<div class="mt-65 collectformbox mb-147" >
				<el-form class="collectform" ref="form" :model="postshu" label-width="0">
					<el-form-item label="" required class="">
						<div class="collect_points-a4 ">
							<div class="tit-16 pl-25" style="color: #333333;width: auto;">Model Type <span style="color: #FF0005;">*</span></div>
							<!-- 逆变器自动完成：加载状态+核心回调 -->
							<el-autocomplete 
								:fetch-suggestions="qiuqiumodeltype" 
								size="medium" 
								class="PostFrominput" 
								v-model="postshu.modeltype"
								placeholder-class="tit-16"
								:loading="modelTypeLoading"
							></el-autocomplete>
						</div>
					</el-form-item>
					<el-form-item label="" required class="">
						<div class="collect_points-a4 ">
							<div class="tit-16 pl-25" style="color: #333333;width:auto;">SN<span style="color: #FF0005;">*</span></div>
							<el-input  
								@blur="sendsn" 
								size="medium" 
								class="PostFrominput" 
								v-model="postshu.sn"
								placeholder-class="tit-16" 
								maxlength="80" 
								minlength="10"
							></el-input>
						</div>
					</el-form-item>
					<el-form-item label=""  class="pt-14">
						<div style="border-top: 1px dashed #AEAEAE;" class=" pb-17"></div>
					</el-form-item>
					<el-form-item label="" required class="">
						<div class="battery-group-container">
							<div 
								v-for="(l,i) in postshu.batteryList" 
								:key="i" 
								class="battery-input-row"
								:class="{hasdel:i!== 0}"
							>
								<div class="collect_points-a4 mb-17">
									<div class="tit-16 pl-25 PostFrominput2-title" style="color: #333333;">Battery Type (if any)<span style="color: #FF0005;">*</span></div>
									<!-- 电池自动完成：独立加载+核心回调 -->
									<el-autocomplete 
										:fetch-suggestions="(query, cb) => querySearchAsync(query, cb, i)"
										size="medium" 
										class="PostFrominput PostFrominput2" 
										v-model="l.batteryType"
										@select="handleSelect"	
										placeholder-class="tit-16"
										:loading="batteryLoading[i]"
									></el-autocomplete>
								</div>
								<div class="collect_points-a4">
									<div class="tit-16 pl-25 PostFrominput2-title" style="color: #333333;">Battery SN (if any)<span style="color: #FF0005;">*</span></div>
									<el-input  
										@blur="sendsn2(l,i)" 
										size="medium" 
										class="PostFrominput PostFrominput2" 
										v-model="l.batterySn" 
										placeholder-class="tit-16" 
										
									></el-input>
								</div>
								<!-- 删除按钮：悬浮显示 -->
								<div class="delBatteryType el-icon-error tit-28" v-if="i !== 0" @click="delget(i)"></div>
							</div>
							<!-- 添加电池按钮 -->
							<div class="addBatteryType">
								<div @click="addget" class="add-btn el-icon-plus tit-20 b-500" style="color: #6a6a6a;"></div>
								<div class="tit-16 ml-7" style="color: #333333;height: .42rem;line-height: .42rem;">Add battery</div>
							</div>
						</div>
					</el-form-item>
					<div class="flex j-center mt-40 pb-30 ">
						<el-button class="querensong tit-18 ys-0 cur_pointer br-25" @click="tijiao">Submit</el-button>
					</div>
				</el-form>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import { queryModel, validateSn ,serialnumberuse} from '@/api/colleect.js';

	export default {
		data() {
			return {
				postshu: {
					modeltype: '',
					sn: '',
					// 修复：字段名和模板v-model统一（batteryType/batterySn）
					batteryList: [{ batteryType: '', batterySn: '' }],
					ModelTypelist: [], // 逆变器型号下拉数据
					BatteryTypelist: [], // 电池型号下拉数据
				},
				modelTypeLoading: false, // 逆变器请求加载状态
				batteryLoading: [], // 多电池项独立加载状态（数组对应索引）
			}
		},
		components: { Tou, Foot },
		methods: {
			// 新增电池项：初始化加载状态+统一字段名
			addget() {
				this.postshu.batteryList.push({ batteryType: '', batterySn: '' });
				this.$set(this.batteryLoading, this.postshu.batteryList.length - 1, false);
			},
			// 删除电池项：同步删除加载状态
			delget(index) {
				this.postshu.batteryList.splice(index, 1);
				this.batteryLoading.splice(index, 1);
			},

			/********************* 逆变器Model Type 下拉核心 - 无防抖 *********************/
			qiuqiumodeltype(queryString, cb) {
				// 空值不请求，直接返回空下拉
				if (!queryString) return cb([]);
				this.modelTypeLoading = true;
				queryModel({ model: queryString, type: 1 })
					.then(res => {
						this.postshu.ModelTypelist = res.data || [];
						// 核心：格式化{value: 显示值}，通过cb传给组件渲染下拉
						const result = this.postshu.ModelTypelist.map(item => ({
							value: item.model || item.name || item, // 适配后端任意返回格式
						}));
						cb(result); // 触发下拉显示
					})
					.catch(err => {
						console.error('逆变器型号查询失败：', err);
						cb([]); // 失败也返回空，避免组件报错
					})
					.finally(() => {
						this.modelTypeLoading = false;
					});
			},

			/********************* 电池Battery Type 下拉核心 - 无防抖 *********************/
			querySearchAsync(queryString, cb, index) {
				if (!queryString) return cb([]);
				this.$set(this.batteryLoading, index, true);
				queryModel({ model: queryString, type: 2 })
					.then(res => {
						this.postshu.BatteryTypelist = res.data || [];
						// 核心：同逆变器，格式化后通过cb返回
						const result = this.postshu.BatteryTypelist.map(item => ({
							value: item.model || item.name || item,
						}));
						cb(result); // 触发下拉显示
					})
					.catch(err => {
						console.error(`第${index+1}个电池型号查询失败：`, err);
						cb([]);
					})
					.finally(() => {
						this.$set(this.batteryLoading, index, false);
					});
			},

			/********************* SN校验 *********************/
			sendsn(e) {
				console.log(e)
				if (!e) return; // 空值不请求
				validateSn({ sn:this.postshu.sn, type: 1}).then(shu => {
					if(shu.code!=200){
						this.$message({
						  showClose: true,
						  message:shu.message,
						  type: 'error',
						  offset:'150',
						  duration:2000
						});
						this.postshu.sn=''
					}
					
				});
			},
			// 多电池项SN校验：传索引区分
			sendsn2(val,i) {
				validateSn({ sn: val.batterySn, type:2}).then(shu => {
					if(shu.code!=200){
						this.$message({
						  showClose: true,
						  message:shu.message,
						  type: 'error',
						  offset:'150',
						  duration:2000
						});
						 this.postshu.batteryList[i].batterySn=''
					}
				});
			},
			tijiao(){
				console.log(this.postshu)
				let sershu={}
				sershu.batteryList=this.postshu.batteryList
				sershu.modelType=this.postshu.modeltype
				sershu.sn=this.postshu.sn
				serialnumberuse(sershu).then(s=>{
					if(s.code!=200){
						this.$message({
						  showClose: true,
						  message:s.message,
						  type: 'error',
						  offset:'150',
						  duration:2000
						});
					}
				})
			},
			// 下拉选中事件：获取选中的型号值
			handleSelect(item) {
				console.log('选中的电池型号：', item.value);
				// 后续可加选中后的联动逻辑
			},
		}
	}
</script>

<style lang="scss">
.collect_points-a4 {
		height:61px;
		min-height: 30px;
		width:100%;
		border: 1px solid #D8D8D8;
		border-radius: 5px;
		overflow: hidden;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		.el-input, .el-autocomplete {
			height: 100%;
			// width: 100%;
			.el-input__inner {
				height: 100%;
				border-radius: 5px;
				border: none;
			}
		}
	}
	.querensong {
		background-image: linear-gradient(4deg, rgb(255, 117, 88) 0%, rgb(230, 0, 18) 100%);
		color: #fff;
		border: 0;
	}
	.collectformbox{
		width:6.23rem;margin-left:auto;margin-right:auto;
	}
	.collectform{
		.el-form-item{
				margin-bottom:19px;
				.el-form-item__content{
					line-height: normal;
				}
		}
	}
	.battery-group-container {
		position: relative;
	}
	.battery-input-row {
		margin-bottom: 20px;
		align-items: center;
		position: relative;
		&:hover .delBatteryType {
			opacity: 1;
		}
	}
	// 添加按钮样式
	.addBatteryType{
		position: absolute;
		right: -25%;
		bottom: 9px;
		display: flex;
		align-items: center;
		.add-btn{
			width: .42rem;
			height: .42rem;
			border-radius: 50%;
			background:#F2F2F2;
			line-height: .42rem;
			text-align: center;
			cursor: pointer;
			color: #6a6a6a;
		}
	}
	// 删除按钮：悬浮显示+鼠标手型
	.delBatteryType{
		transition: opacity 0.2s ease;
		position: absolute;
		top: -6px;
		right: -10px;
		color: #ff0004;
		opacity:0;
		cursor: pointer;
	}
	.PostFrominput2{
		width: 68%;
	}
	.PostFrominput2-title{
		width: 32%;
	}
	@media screen and (min-width: 200px) and (max-width: 768px) {
		.collectformtitle{
			font-size: .36rem;
		}
		.collectformtitle2,.collectformtitle3{
			font-size: .18rem;
		}
		.collectformbox{
			width:84%
		}
		.addBatteryType{
			position: unset;
		}
		.PostFrominput2{
			width: 49%;
		}
		.PostFrominput2-title{
			width: 50%;
		}
	}
	@media screen and (min-width: 768px) and (max-width:1024px) {
		.collectformbox{
			width:60%
			
		}
		.PostFrominput2-title{
			width:34%;
		}
		.PostFrominput2{
			width: 66%;
		}
		.add-btn{
			width: 0.62rem !important;
			height: 0.62rem !important;
			line-height: 0.62rem !important;
		}
		.addBatteryType{
			right: -29%;
		}
	}
	@media screen and (min-width:1024px) and (max-width:1366px) {
		.collectformbox{
			width:49%
		}
		.addBatteryType{
			right: -26%;
		}
	}
	@media screen and (min-width:1024px) and (max-width:1256px) {
		.collectformbox{
			width:60%
			
		}
	}
</style>